/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Prev_Result_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Previous result" |
*
* @param {Find_Replace_Prev_Result_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_prev_result_aria_label = /** @type {((inputs?: Find_Replace_Prev_Result_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Prev_Result_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resultat precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ergebnis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultato precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущий результат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultado anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("先前结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前回の結果")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला परिणाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultado anterior")
	return /** @type {LocalizedString} */ ("Previous result")
});